import { action, observable } from 'mobx';
import IStore from '../../common/interfaces/app/IStore';

export default class BaseStore implements IStore {
  @observable isLoading: boolean = false;

  @action resetStore = () => {};
}
